export default __webpack_public_path__ + "static/media/sleigh-bells-crop.b7e2fb6b.jpg";